export default __webpack_public_path__ + "static/media/404_Confident.7f870d23.svg";